export default __webpack_public_path__ + "static/media/ssimg2.c1cade6f.jpg";